import { API_URL } from "./constant";

// getting pre signed url
// export async function getUrl(formData){
//     try{
//         const response = await fetch(`${API_URL}/generate_presigned_url/`,{
//             method:"POST",
//             body:formData
//         });

//         const responseData = await response.json();
//         if (!response.ok) {
//             throw { status: response.status, data: responseData };
//         }
//         return responseData
//     }catch(error){
//         console.log("error when getting pre url:",error)
//     }
// }

async function attemptGetPresignedUrl(formData) {
    const response = await fetch(`${API_URL}/generate_presigned_url/`, {
        method: "POST",
        body: formData,
    });

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error('Failed to get presigned URL');
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

export async function getUrl(formData) {
    try {
        return await attemptGetPresignedUrl(formData);
    } catch (error) {
        console.error("Error when getting pre-signed URL:", error?.data || error.message);
        throw error;
    }
}

// upload completion
// export async function uploadCompletion(formData){
//     try{
//         const response = await  fetch(`${API_URL}/completion_api/`,{
//             method:"POST",
//             body:formData
//         });
//         const responseData = await response.json();
//         if (!response.ok) {
//             throw { status: response.status, data: responseData };
//         }
//         return responseData
//     }catch(error){
//         console.log("error while calling upload completion api:",error)
//     }
// }
async function attemptUploadCompletion(formData) {
    const response = await fetch(`${API_URL}/completion_api/`, {
        method: "POST",
        body: formData,
    });

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error('Failed to upload completion data');
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

export async function uploadCompletion(formData) {
    try {
        return await attemptUploadCompletion(formData);
    } catch (error) {
        console.error("Error while calling upload completion API:", error?.data || error.message);
        throw error;
    }
}

// export async function uploadFiles(formData) {
//     try {
//         const response = await fetch(`${API_URL}/upload/`, {
//             method: "POST",
//             body: formData,
//         });

//         const responseData = await response.json();

//         if (!response.ok) {
//             throw { status: response.status, data: responseData };
//         }

//         // console.log("upload:", responseData);
//         return responseData;
//     } catch (error) {
//         console.error("Error uploading file:", error);

//         // Ensure error is an object with data
//         throw error.status
//             ? error
//             : { status: 500, data: { message: "Something went wrong while uploading!" } };
//     }
// }

async function attemptFileUpload(formData) {
    const response = await fetch(`${API_URL}/upload/`, {
        method: "POST",
        body: formData,
    });

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error('Failed to upload file');
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

export async function uploadFiles(formData) {
    try {
        return await attemptFileUpload(formData);
    } catch (error) {
        console.error("Error uploading file:", error?.data || error.message);

        throw error.status
            ? error
            : { status: 500, data: { message: "Something went wrong while uploading!" } };
    }
}

// export async function getStatus(orderId) {
//     try{
//         const response =  await fetch(`${API_URL}/status/${orderId}`,{
//             method:'GET',
//         })

//         const data = await response.json();

//         return data;
//     }
//     catch(error){
//         // console.error('Error during fetching status:',error)
//     }
// }

// async function attemptGetStatus(orderId) {
//     const response = await fetch(`${API_URL}/status/${orderId}`, {
//         method: 'GET',
//     });

//     const responseData = await response.json();

//     if (!response.ok) {
//         const err = new Error('Failed to fetch status');
//         err.data = responseData;
//         err.status = response.status;
//         throw err;
//     }

//     return responseData;
// }

export async function getStatus(orderId) {
    try {
        return await attemptGetStatus(orderId);
    } catch (error) {
        console.error("Error fetching status:", error?.data || error.message);

        throw error.status
            ? error
            : { status: 500, data: { message: "Something went wrong while fetching status!" } };
    }
}

// export async function getProcessedFiles({orderId,filename}) {
//     try{
//         const response = await fetch(`${API_URL}/processed_files/${orderId}/${filename}`,{
//             method:'GET'
//         })
//         // const response = await fetch(`${API_URL}/processed_files/${orderId}?filename=${filename}`,{
//         //     method:'GET'
//         // })

//         const data = await response.json()
        
//         return data;
//     }
//     catch(error){
//         // console.error('Error fetching data:',error)
//     }
// }

async function attemptGetProcessedFiles(orderId, filename) {
    const response = await fetch(`${API_URL}/processed_files/${orderId}/${filename}`, {
        method: 'GET',
    });

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error('Failed to fetch processed files');
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

export async function getProcessedFiles({ orderId, filename }) {
    try {
        return await attemptGetProcessedFiles(orderId, filename);
    } catch (error) {
        console.error("Error fetching processed files:", error?.data || error.message);

        throw error.status
            ? error
            : { status: 500, data: { message: "Something went wrong while fetching processed files!" } };
    }
}
